import { ArrowRight } from "lucide-react";

export default function PartenairesPage() {
  const categories = [
    {
      title: "Supermarchés",
      slug: "supermarches",
      description:
        "Des enseignes engagées qui soutiennent l’association à travers des collectes, des relais locaux et des actions solidaires.",
      image:
        "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1600&q=80",
    },
    {
      title: "Vétérinaires",
      slug: "veterinaires",
      description:
        "Des professionnels de santé animale qui accompagnent l’association dans les soins, les urgences et le suivi médical.",
      image:
        "https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?auto=format&fit=crop&w=1600&q=80",
    },
    {
      title: "Autres partenaires",
      slug: "autres",
      description:
        "Entreprises, commerces, associations et acteurs locaux qui participent à la protection animale.",
      image:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=80",
    },
  ];

  return (
    <div className="min-h-screen bg-[#fbfbf9] text-[#111111]">
      
      <main>
        {/* HEADER */}
        <section className="border-b border-black/6 px-6 pb-10 pt-16 lg:px-10 lg:pb-14 lg:pt-20">
          <div className="mx-auto max-w-7xl">
            <p className="text-xs uppercase tracking-[0.35em] text-black/40">
              Partenaires
            </p>

            <h1 className="mt-4 max-w-5xl text-5xl font-semibold leading-[0.95] md:text-6xl xl:text-7xl">
              Un réseau engagé
              <span className="block text-red-600">
                aux côtés de Savoinimaux.
              </span>
            </h1>

            <p className="mt-6 max-w-3xl text-base leading-8 text-black/62 md:text-lg">
              Explorez les grandes familles de partenaires qui accompagnent
              l’association. Chaque catégorie ouvre sur un univers dédié,
              avec une navigation immersive et plus visuelle.
            </p>
          </div>
        </section>

        {/* FULL SCREEN CARDS */}
        <section className="px-4 py-4 md:px-6 lg:px-8 xl:px-10 xl:py-6">
          <div className="grid min-h-[calc(100vh-180px)]  gap-4 lg:grid-cols-3">
            {categories.map((category) => (
              <a
                key={category.slug}
                href={`/partenaires/${category.slug}`}
                className="group relative min-h-[520px] overflow-hidden rounded-[2rem] border border-black/8 shadow-[0_24px_80px_rgba(0,0,0,0.06)] lg:min-h-[720px]"
              >
                {/* IMAGE */}
                <img
                  src={category.image}
                  alt={category.title}
                  className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-[1.05]"
                />

                {/* OVERLAYS */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10" />
                <div className="absolute inset-0 bg-gradient-to-r from-red-600/20 via-transparent to-transparent" />

                {/* TOP */}
                <div className="absolute left-6 right-6 top-6 flex justify-between">
                  <span className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-[11px] uppercase tracking-[0.3em] text-white backdrop-blur-md">
                    Catégorie
                  </span>

                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-md transition group-hover:translate-x-1">
                    <ArrowRight className="h-4 w-4" />
                  </span>
                </div>

                {/* CONTENT */}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 xl:p-10">
                  <div className="rounded-[1.8rem] border border-white/15 bg-white/10 p-6 backdrop-blur-xl">
                    <p className="text-xs uppercase tracking-[0.34em] text-white/70">
                      Savoinimaux
                    </p>

                    <h2 className="mt-4 text-3xl font-semibold text-white md:text-4xl xl:text-5xl">
                      {category.title}
                    </h2>

                    <p className="mt-4 text-sm leading-7 text-white/80 md:text-base">
                      {category.description}
                    </p>

                    <div className="mt-6 flex items-center gap-2 text-sm font-semibold text-white">
                      Découvrir
                      <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}